var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYeswareSalesEmailTemplates = function SvgYeswareSalesEmailTemplates(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 19.422,
    fill: "#ECF6FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m57.386 26.914-7.992-7.993a3.693 3.693 0 0 0-2.612-1.082H25.227a3.694 3.694 0 0 0-3.694 3.693v36.936a3.694 3.694 0 0 0 3.694 3.693h29.548a3.694 3.694 0 0 0 3.694-3.693V29.525c0-.98-.39-1.919-1.083-2.611ZM38.154 53.85h-8.31a1.847 1.847 0 1 1 0-3.694h8.31a1.847 1.847 0 0 1 0 3.694Zm8.31-7.387h-16.62a1.847 1.847 0 1 1 0-3.694h16.62a1.847 1.847 0 0 1 0 3.694Zm0-7.387h-16.62a1.847 1.847 0 0 1 0-3.694h16.62a1.846 1.846 0 1 1 0 3.694Z",
    fill: "#29ABE2"
  })));
};
export default SvgYeswareSalesEmailTemplates;